import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import React from 'react';

import type { Props as MenuLinkProps } from '../MenuLink/MenuLink';
import MenuLink from '../MenuLink/MenuLink';

import styles from './DefaultLink.scss';

export interface Props extends MenuLinkProps {
  icons?: React.ReactElement;
  hasChevron?: boolean;
}

const DefaultLink: React.FC<Props> = ({ children, hasChevron = true, ...rest }) => (
  <MenuLink hasPadding={hasChevron} {...rest}>
    <span className={styles.linkWrapper}>
      {children}
      {hasChevron ? <Icon icon={ChevronMediumDown} className={styles.linkIcon} size="sm" /> : null}
    </span>
  </MenuLink>
);

export default DefaultLink;
